// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/environment.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateEnvironmentAccessTokenRequest, CreateEnvironmentAccessTokenResponse, CreateEnvironmentFromProjectRequest, CreateEnvironmentFromProjectResponse, CreateEnvironmentLogsTokenRequest, CreateEnvironmentLogsTokenResponse, CreateEnvironmentRequest, CreateEnvironmentResponse, DeleteEnvironmentRequest, DeleteEnvironmentResponse, GetEnvironmentRequest, GetEnvironmentResponse, ListEnvironmentsRequest, ListEnvironmentsResponse, MarkEnvironmentActiveRequest, MarkEnvironmentActiveResponse, StartEnvironmentRequest, StartEnvironmentResponse, StopEnvironmentRequest, StopEnvironmentResponse, UnarchiveEnvironmentRequest, UnarchiveEnvironmentResponse, UpdateEnvironmentRequest, UpdateEnvironmentResponse } from "./environment_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";
import { ListEnvironmentClassesRequest, ListEnvironmentClassesResponse } from "./runner_configuration_pb.js";

/**
 * @generated from service gitpod.v1.EnvironmentService
 */
export const EnvironmentService = {
  typeName: "gitpod.v1.EnvironmentService",
  methods: {
    /**
     * Gets details about a specific environment including its status, configuration, and context URL.
     *
     * Use this method to:
     * - Check if an environment is ready to use
     * - Get connection details for IDE and exposed ports
     * - Monitor environment health and resource usage
     * - Debug environment setup issues
     *
     * ### Examples
     *
     * - Get environment details:
     *
     *   Retrieves detailed information about a specific environment using its unique identifier.
     *
     *   ```yaml
     *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentService.GetEnvironment
     */
    getEnvironment: {
      name: "GetEnvironment",
      I: GetEnvironmentRequest,
      O: GetEnvironmentResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Lists all environments matching the specified criteria.
     *
     * Use this method to find and monitor environments across your organization.
     * Results are ordered by creation time with newest environments first.
     *
     * ### Examples
     *
     * - List running environments for a project:
     *
     *   Retrieves all running environments for a specific project with pagination.
     *
     *   ```yaml
     *   filter:
     *     statusPhases: ["ENVIRONMENT_PHASE_RUNNING"]
     *     projectIds: ["b0e12f6c-4c67-429d-a4a6-d9838b5da047"]
     *   pagination:
     *     pageSize: 10
     *   ```
     *
     * - List all environments for a specific runner:
     *
     *   Filters environments by runner ID and creator ID.
     *
     *   ```yaml
     *   filter:
     *     runnerIds: ["e6aa9c54-89d3-42c1-ac31-bd8d8f1concentrate"]
     *     creatorIds: ["f53d2330-3795-4c5d-a1f3-453121af9c60"]
     *   ```
     *
     * - List stopped and deleted environments:
     *
     *   Retrieves all environments in stopped or deleted state.
     *
     *   ```yaml
     *   filter:
     *     statusPhases: ["ENVIRONMENT_PHASE_STOPPED", "ENVIRONMENT_PHASE_DELETED"]
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentService.ListEnvironments
     */
    listEnvironments: {
      name: "ListEnvironments",
      I: ListEnvironmentsRequest,
      O: ListEnvironmentsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Lists available environment classes with their specifications and resource limits.
     *
     * Use this method to understand what types of environments you can create and their
     * capabilities. Environment classes define the compute resources and features available
     * to your environments.
     *
     * ### Examples
     *
     * - List all available classes:
     *
     *   Retrieves a list of all environment classes with their specifications.
     *
     *   ```yaml
     *   {}
     *   ```
     * buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     *
     * @generated from rpc gitpod.v1.EnvironmentService.ListEnvironmentClasses
     */
    listEnvironmentClasses: {
      name: "ListEnvironmentClasses",
      I: ListEnvironmentClassesRequest,
      O: ListEnvironmentClassesResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Creates a development environment from a context URL (e.g. Git repository) and starts it.
     *
     * The `class` field must be a valid environment class ID. You can find a list of
     * available environment classes with the `ListEnvironmentClasses` method.
     *
     * ### Examples
     *
     * - Create from context URL:
     *
     *   Creates an environment from a Git repository URL with default settings.
     *
     *   ```yaml
     *   spec:
     *     machine:
     *       class: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *     content:
     *       initializer:
     *         specs:
     *           - contextUrl:
     *               url: "https://github.com/gitpod-io/gitpod"
     *   ```
     *
     * - Create from Git repository:
     *
     *   Creates an environment from a Git repository with specific branch targeting.
     *
     *   ```yaml
     *   spec:
     *     machine:
     *       class: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *     content:
     *       initializer:
     *         specs:
     *           - git:
     *               remoteUri: "https://github.com/gitpod-io/gitpod"
     *               cloneTarget: "main"
     *               targetMode: "CLONE_TARGET_MODE_REMOTE_BRANCH"
     *   ```
     *
     * - Create with custom timeout and ports:
     *
     *   Creates an environment with custom inactivity timeout and exposed port configuration.
     *
     *   ```yaml
     *   spec:
     *     machine:
     *       class: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *     content:
     *       initializer:
     *         specs:
     *           - contextUrl:
     *               url: "https://github.com/gitpod-io/gitpod"
     *     timeout:
     *       disconnected: "7200s"  # 2 hours in seconds
     *     ports:
     *       - port: 3000
     *         admission: "ADMISSION_LEVEL_EVERYONE"
     *         name: "Web App"
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentService.CreateEnvironment
     */
    createEnvironment: {
      name: "CreateEnvironment",
      I: CreateEnvironmentRequest,
      O: CreateEnvironmentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates an environment from an existing project configuration and starts it.
     *
     * This method uses project settings as defaults but allows overriding specific
     * configurations. Project settings take precedence over default configurations,
     * while custom specifications in the request override project settings.
     *
     * ### Examples
     *
     * - Create with project defaults:
     *
     *   Creates an environment using all default settings from the project configuration.
     *
     *   ```yaml
     *   projectId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   ```
     *
     * - Create with custom compute resources:
     *
     *   Creates an environment from project with custom machine class and timeout settings.
     *
     *   ```yaml
     *   projectId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   spec:
     *     machine:
     *       class: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *     timeout:
     *       disconnected: "14400s"  # 4 hours in seconds
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentService.CreateEnvironmentFromProject
     */
    createEnvironmentFromProject: {
      name: "CreateEnvironmentFromProject",
      I: CreateEnvironmentFromProjectRequest,
      O: CreateEnvironmentFromProjectResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Starts a stopped environment.
     *
     * Use this method to resume work on a previously stopped environment. The environment
     * retains its configuration and workspace content from when it was stopped.
     *
     * ### Examples
     *
     * - Start an environment:
     *
     *   Resumes a previously stopped environment with its existing configuration.
     *
     *   ```yaml
     *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentService.StartEnvironment
     */
    startEnvironment: {
      name: "StartEnvironment",
      I: StartEnvironmentRequest,
      O: StartEnvironmentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Stops a running environment.
     *
     * Use this method to pause work while preserving the environment's state.
     * The environment can be resumed later using StartEnvironment.
     *
     * ### Examples
     *
     * - Stop an environment:
     *
     *   Gracefully stops a running environment while preserving its state.
     *
     *   ```yaml
     *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentService.StopEnvironment
     */
    stopEnvironment: {
      name: "StopEnvironment",
      I: StopEnvironmentRequest,
      O: StopEnvironmentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Updates an environment's configuration while it is running.
     *
     * Updates are limited to:
     * - Git credentials (username, email)
     * - SSH public keys
     * - Content initialization
     * - Port configurations
     * - Automation files
     * - Environment timeouts
     *
     * ### Examples
     *
     * - Update Git credentials:
     *
     *   Updates the Git configuration for the environment.
     *
     *   ```yaml
     *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   spec:
     *     content:
     *       gitUsername: "example-user"
     *       gitEmail: "user@example.com"
     *   ```
     *
     * - Add SSH public key:
     *
     *   Adds a new SSH public key for authentication.
     *
     *   ```yaml
     *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   spec:
     *     sshPublicKeys:
     *       - id: "0194b7c1-c954-718d-91a4-9a742aa5fc11"
     *         value: "ssh-ed25519 AAAAC3NzaC1lZDI1NTE5AAAAI..."
     *   ```
     *
     * - Update content session:
     *
     *   Updates the content session identifier for the environment.
     *
     *   ```yaml
     *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   spec:
     *     content:
     *       session: "0194b7c1-c954-718d-91a4-9a742aa5fc11"
     *   ```
     *
     * Note: Machine class changes require stopping the environment and creating a new one.
     *
     * @generated from rpc gitpod.v1.EnvironmentService.UpdateEnvironment
     */
    updateEnvironment: {
      name: "UpdateEnvironment",
      I: UpdateEnvironmentRequest,
      O: UpdateEnvironmentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Permanently deletes an environment.
     *
     * Running environments are automatically stopped before deletion. If force
     * is true, the environment is deleted immediately without graceful shutdown.
     *
     * ### Examples
     *
     * - Delete with graceful shutdown:
     *
     *   Deletes an environment after gracefully stopping it.
     *
     *   ```yaml
     *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   force: false
     *   ```
     *
     * - Force delete:
     *
     *   Immediately deletes an environment without waiting for graceful shutdown.
     *
     *   ```yaml
     *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   force: true
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentService.DeleteEnvironment
     */
    deleteEnvironment: {
      name: "DeleteEnvironment",
      I: DeleteEnvironmentRequest,
      O: DeleteEnvironmentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates an access token for retrieving environment logs.
     *
     * Generated tokens are valid for one hour and provide read-only access
     * to the environment's logs.
     *
     * ### Examples
     *
     * - Generate logs token:
     *
     *   Creates a temporary access token for retrieving environment logs.
     *
     *   ```yaml
     *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentService.CreateEnvironmentLogsToken
     */
    createEnvironmentLogsToken: {
      name: "CreateEnvironmentLogsToken",
      I: CreateEnvironmentLogsTokenRequest,
      O: CreateEnvironmentLogsTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates an access token for the environment.
     *
     * Generated tokens are valid for one hour and provide environment-specific access permissions.
     * The token is scoped to a specific environment.
     *
     * ### Examples
     *
     * - Generate environment token:
     *
     *   Creates a temporary access token for accessing an environment.
     *
     *   ```yaml
     *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentService.CreateEnvironmentAccessToken
     */
    createEnvironmentAccessToken: {
      name: "CreateEnvironmentAccessToken",
      I: CreateEnvironmentAccessTokenRequest,
      O: CreateEnvironmentAccessTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Records environment activity to prevent automatic shutdown.
     *
     * Activity signals should be sent every 5 minutes while the environment
     * is actively being used. The source must be between 3-80 characters.
     *
     * ### Examples
     *
     * - Signal VS Code activity:
     *
     *   Records VS Code editor activity to prevent environment shutdown.
     *
     *   ```yaml
     *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   activitySignal:
     *     source: "VS Code"
     *     timestamp: "2025-02-12T14:30:00Z"
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentService.MarkEnvironmentActive
     */
    markEnvironmentActive: {
      name: "MarkEnvironmentActive",
      I: MarkEnvironmentActiveRequest,
      O: MarkEnvironmentActiveResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Unarchives an environment.
     *
     * ### Examples
     *
     * - Unarchive an environment:
     *
     *   ```yaml
     *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   ```
     *
     * @generated from rpc gitpod.v1.EnvironmentService.UnarchiveEnvironment
     */
    unarchiveEnvironment: {
      name: "UnarchiveEnvironment",
      I: UnarchiveEnvironmentRequest,
      O: UnarchiveEnvironmentResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

